import { ISummaryPageSettings } from '../../../models/summary/ISummaryPageSettings';
import { ISummaryData } from '../../../models/summary/ISummaryData';
import styles from './summary-degree-list-old.module.scss';
import { useEffect, useState } from 'react';
import { ISummaryCourse } from '../../../models/summary/ISummaryCourse';
import SummaryDegreeOld from '../summary-degree-old/summary-degree-old';

type Props = {
  degrees: ISummaryData[];
  summaryPageSettings: ISummaryPageSettings;
  pagingLimit: number;
  brandName: string;
  googleTagId?: string;
  courseList?: ISummaryCourse[];
};
export default function SummaryDegreeListOld({
  degrees,
  pagingLimit,
  summaryPageSettings,
  brandName,
  googleTagId,
  courseList,
}: Props) {
  const [searchInput, setSearchInput] = useState('');
  const [scrollValue, setScrollValue] = useState<number>(0);
  let [degreeList, setDegrees] = useState<ISummaryData[]>(degrees.slice(0, pagingLimit));

  useEffect(() => {
    setDegrees(degrees.slice(0, pagingLimit));
  }, [degrees]);

  const handleChange = (e) => {
    e.preventDefault();
    setSearchInput(e.target.value);
  };

  if (searchInput.length > 0) {
    degrees = degrees.filter((degree) => {
      return degree.name.toLowerCase().match(searchInput.toLowerCase());
    });
    degreeList = degrees.slice(0, pagingLimit);
  }

  const onScroll = (event) => {
    const {
      target: { body, documentElement },
    } = event;
    const scrollTop = body.scrollTop || documentElement.scrollTop;
    const height = documentElement.scrollHeight - documentElement.clientHeight;
    const scrolled = scrollTop / height;
    setScrollValue(scrolled);
  };

  useEffect(() => {
    window.addEventListener(`scroll`, onScroll);

    return () => {
      window.removeEventListener(`scroll`, onScroll);
    };
  }, []);

  const loadDegreeList = () => {
    const length = degreeList != null ? degreeList?.length : 0;
    const progressionRemainingLength = degreeList?.length + pagingLimit;
    const remainingProgression = Array.from(degrees).slice(length, progressionRemainingLength);
    setDegrees([...degreeList, ...remainingProgression]);
  };

  useEffect(() => {
    const length = degreeList != null ? degreeList?.length : 0;
    if (scrollValue > 0.95 && length < degrees.length) {
      loadDegreeList();
    }
  }, [scrollValue]);

  return (
    <div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <input
            type='search'
            className={styles[`search-box`]}
            onChange={handleChange}
            value={searchInput}
            placeholder='Start typing program name'
            aria-label='start typing here to search for your desired program'
          />
        </div>
      </div>
      {degreeList?.length > 0 ? (
        degreeList.map((degree) => (
          <SummaryDegreeOld
            key={degree.id}
            degree={degree}
            summaryPageSettings={summaryPageSettings}
            brandName={brandName}
            googleTagId={googleTagId}
            courseList={courseList}
          />
        ))
      ) : (
        <div className='mt-4'>
          <p>No result found, please search again</p>
        </div>
      )}
    </div>
  );
}
